import api from '../../../services/api';

const URL = '/license-plans/';
const BILLING_URL = '/organization_billing';

class LicenseService {
    getSummary() {
        return api.get(URL + 'summary');
    }

    getPricing() {
        return api.get(URL + 'pricing');
    }

    getFeatures() {
        return api.get(URL + 'features');
    }

    purchaseLicensePlan(planKey, data) {
        return api.post(URL + planKey + '/purchase', data);
    }

    purchaseWithItems(data) {
        return api.post('/license_plans/purchase_with_items', data);
    }

    switchPlan(newPlanKey, billingPeriod) {
        const body = { new_plan: newPlanKey };
        if (billingPeriod) body.billing_period = billingPeriod;
        return api.post('/license_plans/switch_plan', body);
    }

    previewSwitch(data) {
        return api.post('/license_plans/switch_plan/preview', data);
    }

    previewPromo(data) {
        return api.post('/license-plans/promo/preview', data);
    }

    getBilling() {
        return api.get(BILLING_URL);
    }

    createSetupIntent() {
        return api.post(BILLING_URL + '/setup_intent', {});
    }

    setDefaultPaymentMethod(paymentMethodId) {
        return api.post(BILLING_URL + '/payment_method/default', { payment_method_id: paymentMethodId });
    }

    detachPaymentMethod(paymentMethodId) {
        return api.post(BILLING_URL + '/payment_method/detach', { payment_method_id: paymentMethodId });
    }

    confirmPayment(data) {
        return api.post(URL + 'confirm-payment', data);
    }

    purchaseFeature(featureKey, data) {
        return api.post(URL + 'features/' + featureKey + '/purchase', data);
    }

    confirmFeaturePayment(data) {
        return api.post(URL + 'features/confirm-payment', data);
    }

    cancelPendingSubscription(subscriptionId) {
        return api.post('/license_plans/cancel_pending', { subscription_id: subscriptionId });
    }

    cancelSubscription(organizationLicenseId) {
        return api.post(`/organization_licenses/${organizationLicenseId}/cancel`);
    }

    cancelFeature(organizationLicenseFeatureId) {
        return api.post('/license-plans/cancel_feature', { organization_license_feature_id: organizationLicenseFeatureId });
    }

    getSubscription() {
        return api.get('/organization/subscription');
    }

    getEmailUsage() {
        return api.get('/organization/email_usage');
    }

    getStorageUsage(params = {}) {
        return api.get('/organization/storage_usage', { params });
    }

    getInvoices(params = {}) {
        return api.get(BILLING_URL + '/invoices', { params });
    }

    getStripeCustomerPayload() {
        return api.get(BILLING_URL + '/stripe_customer_payload');
    }
}

export default new LicenseService();
